export type PaymentStatus = "idle" | "processing" | "slow" | "checking";

/** How long before a payment is considered "slow" and we show extra UI feedback. */
export const SLOW_THRESHOLD_MS = 10_000;

/** Interval between status-poll attempts after a network error. */
export const STATUS_POLL_INTERVAL_MS = 5_000;

/** Maximum time we'll keep polling for a transaction status (5 minutes). */
export const STATUS_POLL_MAX_MS = 5 * 60 * 1_000;
